import React from 'react'
import useTrans from '../../../hooks/useTrans'
import { Checkmark } from '../NewIcons'

const Step = ({ label, index, disabled, completed }) => {
  const t = useTrans()
  return (
    <div
      className={
        'step' + (disabled ? ' step--disabled' : '') + (completed ? ' step--completed' : '')
      }
    >
      <div className="step__nav">
        <span className="step__dot">{completed ? <Checkmark /> : index}</span>
      </div>
      <span className="step__label">{t(label)}</span>
    </div>
  )
}

const StepBar = ({ stepsLabels, currentStep, navActive }) => {
  return (
    <div className="stepbar">
      {stepsLabels.map((label, index) => (
        <Step
          key={index}
          label={label}
          index={index + 1}
          disabled={navActive && index + 1 > currentStep}
          completed={navActive && index + 1 < currentStep}
        />
      ))}
    </div>
  )
}

export default StepBar
